import React from 'react';
import styled from 'styled-components';
import './App.css';
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { Root } from './Root'
import store from './store'


const PageWrapper = styled.div`
  margin-top: 30px;
`;
console.log(PageWrapper)
// Check out routes in the BR app to figure out switching actual pages

class App extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <Root/>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;